module.exports = __webpack_public_path__ + "static/lifting-e85ae6d22e52c374ec859efb2e49429b.jpg";